
const STATES = {
    "alabama": "al",
    "alaska": "ak",
    "arizona": "az",
    "arkansas": "ar",
    "california": "ca",
    "colorado": "co",
    "connecticut": "ct",
    "delaware": "de",
    "district of columbia": "dc",
    "florida": "fl",
    "georgia": "ga",
    "hawaii": "hi",
    "idaho": "id",
    "illinois": "il",
    "indiana": "in",
    "iowa": "ia",
    "kansas": "ks",
    "kentucky": "ky",
    "louisiana": "la",
    "maine": "me",
    "maryland": "md",
    "massachusetts": "ma",
    "michigan": "mi",
    "minnesota": "mn",
    "mississippi": "ms",
    "missouri": "mo",
    "montana": "mt",
    "nebraska": "ne",
    "nevada": "nv",
    "new hampshire": "nh",
    "new jersey": "nj",
    "new mexico": "nm",
    "new york": "ny",
    "north carolina": "nc",
    "north dakota": "nd",
    "ohio": "oh",
    "oklahoma": "ok",
    "oregon": "or",
    "pennsylvania": "pa",
    "puerto rico": "pr",
    "rhode island": "ri",
    "south carolina": "sc",
    "south dakota": "sd",
    "tennessee": "tn",
    "texas": "tx",
    "utah": "ut",
    "vermont": "vt",
    "virginia": "va",
    "virgin islands": "vi",
    "washington": "wa",
    "west virginia": "wv",
    "wisconsin": "wi",
    "wyoming": "wy"
}

const REGIONS = {
    'new-england': ['me', 'nh', 'vt', 'ma', 'ct', 'ri'],
    'mid-atlantic': ['ny', 'nj', 'pa', 'md', 'de', 'dc', 'va', 'wv'],
    'southeast': ['nc', 'sc', 'ga', 'fl', 'al', 'ms', 'la', 'ar', 'tn', 'ky'],
    'midwest': ['oh', 'in', 'mi', 'il', 'wi', 'mn', 'ia', 'mo'],
    'plains': ['nd', 'sd', 'ne', 'ks', 'ok', 'tx'],
    'southwest': ['nm', 'co', 'az', 'ut', 'nv', 'ca'],
    'northwest': ['wa', 'or', 'id', 'mt', 'wy']
}

const VARIABLES = {
    'path-length': {'type': 'number', 'units': 'mi'}, 
    'path-width': {'type': 'number', 'units': 'yds'}, 
    'injuries': {'type': 'number', 'units': ''}, 
    'fatalities': {'type': 'number', 'units': ''}, 
    'state': {'type': 'enum', 'options': Object.values(STATES).concat(Object.keys(STATES))},
    'region': {'type': 'enum', 'options': Object.keys(REGIONS)},
};

const VALID_OPERATORS = {
    'number': ['>', '>=', '=', '<=', '<'],
    'enum': ['='],
    'string': ['='],
};

const OPERATORS = (() => {
    let unique = [...new Set(Object.values(VALID_OPERATORS).flat())];
    unique.sort((a, b) => b.length - a.length);
    return unique;
})();

const DISPLAY_OPS = {
    '>': '>',
    '>=': '\u2265',
    '=': '=',
    '<=': '\u2264',
    '<': '<',
}

const OP_FUNCS = {
    '>': (a, b) => a > b,
    '>=': (a, b) => a >= b,
    '=': (a, b) => a == b,
    '<=': (a, b) => a <= b,
    '<': (a, b) => a < b,
}

class Filter {
    constructor(variable, operator, value) {
        this.variable = variable;
        this.operator = operator;
        this.value = value;

        let op_func = OP_FUNCS[operator];
        if (variable == 'state') {
            op_func = (a, b) => a.includes(b);
        }
        else if (variable == 'region') {
            op_func = (a, b) => REGIONS[b].filter(el => a.includes(el.toUpperCase())).length > 0;
        }

        let units = VARIABLES[variable]['type'] == 'number' ? VARIABLES[variable]['units'] : '';
        units = units == '' ? units : ' ' + units;
        this.display = variable + " " + DISPLAY_OPS[operator] + " " + value + units;

        const db_variable = ['state', 'region'].includes(variable) ? 'states' : variable;
        this.func = tor => op_func(tor['geojson']['properties'][db_variable], value);
    }   
    
    filter(tors) {
        return tors.filter(this.func);
    }

    toHeaderString() {
        const titleCase = str => str.replace(/(^|[\s])\S/, c => c.toUpperCase());

        const var_str = this.variable.split('-').map(str => titleCase(str)).join(' ');
        const op_str = DISPLAY_OPS[this.operator];

        let val_str, units;
        if (VARIABLES[this.variable]['type'] == 'number') {
            units = VARIABLES[this.variable]['units'];
            val_str = this.value;
        }
        else {
            units = '';
            val_str = this.value.split('-').map(str => titleCase(str)).join(' ');
            val_str = val_str == 'Mid Atlantic' ? 'Mid-Atlantic': val_str;
        }
        units = units == '' ? units : ' ' + units;


        return var_str + ' ' + op_str + ' ' + val_str + units;
    }

    static fromString(filter_str) {
        const parsed = Filter.getPossibilities(filter_str);

        if (!parsed['maybe_complete']) {
            return null;
        }

        const variable = parsed['vars'];
        let value = parsed['val']['value'];

        if (variable == 'state') {
            if(value in STATES) {
                value = STATES[value];
            }
            value = value.toUpperCase();
        }

        return new Filter(variable, parsed['ops'], value);
    }

    static getPossibilities(txt) {
        let ret = {};
        const ops_in_txt = OPERATORS.filter(op => txt.includes(op));
        let var_txt, op_txt = null, val_txt = null;
        if (ops_in_txt.length > 0) {
            op_txt = ops_in_txt[0];
            [var_txt, val_txt] = txt.split(op_txt);
            var_txt = var_txt.trim().toLowerCase();
            val_txt = val_txt.trim().toLowerCase();
        }
        else {
            var_txt = txt.trim().toLowerCase();
        }
      
        // It should be possible to generalize some stuff in here and make this a bit more tractible, but I don't have
        //  motivation for that right now.
        const valid_vars = Object.keys(VARIABLES);
        const cand_vars = valid_vars.filter(v => v.startsWith(var_txt));
        ret['vars'] = {'type': 'enum', 'options': cand_vars};
        ret['autocomplete'] = null;
        if (cand_vars.length == 1) {
            // If there's only one possible variable
            const var_name = cand_vars[0];
            if (valid_vars.includes(var_txt)) {
                // If there's only one possible variable, and it's been filled in, then start looking for operators.
                ret['vars'] = var_txt;
                const var_info = VARIABLES[var_name];
      
                const valid_ops = VALID_OPERATORS[var_info['type']];
                if (op_txt !== null) {
                    // The user has entered an operator, so check to see that it's valid
                    if (valid_ops.includes(op_txt)) {
                        // The user has entered a valid operator, so check for the values
                        if (val_txt === null || val_txt === "") {
                            // The user hasn't entered a value yet, so there's a catch. Because the operands are short
                            //  and there's a lot of overlap in the characters, maybe they haven't finished entering it
                            //  yet (e.g., they're in the process of typing '>=', but have only finished '>' now). So
                            //  add an option for both operands and values
                            const cand_ops = valid_ops.filter(o => o.startsWith(op_txt));
                            if (cand_ops.length == 1) {
                                ret['ops'] = cand_ops[0];
                            }
                            else {
                                ret['ops'] = {'type': 'enum', 'options': cand_ops};
                            }
                            if (cand_ops.filter(o => o == op_txt).length > 0) {
                                ret['val'] = var_info;
                            }
                        }
                        else {
                            // The user has entered a value, so parse the values
                            ret['ops'] = op_txt;
                            ret['val'] = {...var_info};

                            if (var_info['type'] == 'enum') {
                                // The value type is an enumeration, so pare down the options
                                const cand_vals = var_info['options'].filter(v => v.startsWith(val_txt));
                                if (cand_vals.length == 1 && cand_vals[0] != val_txt) {
                                    ret['autocomplete'] = txt.toLowerCase().replace(val_txt, cand_vals[0]);
                                }
                                ret['val']['options'] = cand_vals;

                                if (cand_vals.includes(val_txt)) {
                                    ret['val']['value'] = val_txt;
                                }
                            }
                            else {
                                // The value is either a number or a string, so stick the entered value in the object.
                                ret['val']['value'] = val_txt;
                            }
                        }
                    }
                    else {
                        // The user has entered an operator, but not one that's valid for this variable (e.g., entering
                        //  'state>'). No options.
                        ret['ops'] = {'type': 'enum', 'options': []};
                    }   
                }
                else {
                    // The user hasn't entered an operator yet, so give them all the valid choices for this variable.
                    ret['ops'] = {'type': 'enum', 'options': valid_ops};
                    if (valid_ops.length == 1) {
                        ret['autocomplete'] = txt + valid_ops[0];
                    }
                }
            }
            else {
                // If there's only one possible variable, but it hasn't been filled yet, allow autocomplete.
                ret['autocomplete'] = var_name;
            }
        }
      
        ret['maybe_complete'] = (typeof ret['vars'] !== 'object' && typeof ret['ops'] !== 'object' && 'value' in ret['val']);
        return ret;
    }
}

export default Filter;